<template>
  <div>
    <el-dialog v-dialog-drag :visible.sync="showDialog" width="1100px" :destroy-on-close="true" :before-close="cancel"
      :title="type === 'details' ? '查看合同详情' : '审核合同信息'" class="audit-dialog">
      <div class="el-dialog-div">
        <!-- 审核表单区域 -->
        <div class="section-card audit-section" v-if="type !== 'details'">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
            <el-button size="small" type="success" icon="el-icon-check" @click="handleApprove">确认审核</el-button>
          </div>
          <el-form :model="form" label-width="100px" ref="form" :rules="rules" class="audit-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="审核状态" prop="status">
                  <el-radio-group v-model="form.status">
                    <el-radio label="SUCCESS" class="success-radio">
                      <i class="el-icon-success" style="color: #67c23a;"></i> 通过
                    </el-radio>
                    <el-radio label="DEFEAT" class="danger-radio">
                      <i class="el-icon-error" style="color: #f56c6c;"></i> 拒绝
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.status === 'DEFEAT'">
              <el-col :span="24">
                <el-form-item label="驳回理由" prop="rejectionReason">
                  <el-input type="textarea" v-model="form.rejectionReason"
                    placeholder="请输入驳回理由"
                    :rows="3"
                    maxlength="500"
                    show-word-limit></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 已审核信息展示（详情模式） -->
        <div class="section-card audit-section" v-if="type === 'details' && selectDetail.status !== 'APPLYING'">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核信息</span>
          </div>
          <div class="detail-grid" style="padding: 16px;">
            <div class="detail-item">
              <span class="detail-label">审核状态</span>
              <span class="detail-value">
                <el-tag :type="getStatusColor(selectDetail.status, 'tagType')"
                  :style="{color: getStatusColor(selectDetail.status, 'color'),'background-color':getStatusColor(selectDetail.status, 'backgroundColor')}">
                  {{getStatusColor(selectDetail.status, 'name')}}</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">审批人员</span>
              <span class="detail-value">{{ selectDetail.operator || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">审核时间</span>
              <span class="detail-value">{{ selectDetail.auditTime || '-' }}</span>
            </div>
            <div class="detail-item full-width" v-if="selectDetail.status === 'DEFEAT'">
              <span class="detail-label">驳回理由</span>
              <span class="detail-value">{{ selectDetail.rejectionReason || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 合同基础信息 -->
        <div class="section-card">
          <div class="section-header-bar" @click="toggleSection('baseInfo')">
            <div class="section-title"><i class="el-icon-s-order"></i> 合同基础信息</div>
            <i :class="sectionOpen.baseInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.baseInfo">
            <div class="detail-item">
              <span class="detail-label">合同编号</span>
              <span class="detail-value">{{ contractData.contractNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同名称</span>
              <span class="detail-value">{{ contractData.contractName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">销售</span>
              <span class="detail-value">{{ contractData.sales?.name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">有效期限</span>
              <span class="detail-value">
                <el-tag size="small">{{ contractData.expirationDate ? contractData.expirationDate + '年' : '-' }}</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同拟定时间</span>
              <span class="detail-value">{{ contractData.contractDraftingDate }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同金额</span>
              <span class="detail-value"><span class="amount-text">{{ formatAmount(contractData.contractAmount) }}</span></span>
            </div>
            <div class="detail-item"
              v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(contractData.contractType)">
              <span class="detail-label">增值金额</span>
              <span class="detail-value">{{ contractData.addedAmount + '(' +
                getProportion(contractData.contractAmount, contractData.addedAmount) + ')' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">客户联系人</span>
              <span class="detail-value">
                <span v-if="contractData?.customerContacts?.contactName">{{ contractData.customerContacts.contactName }}</span>
                <el-tag v-else type="danger" size="small">系统内未找到</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">受托方</span>
              <span class="detail-value">{{ contractData?.baseCompany?.companyName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">受托方联系人</span>
              <span class="detail-value">{{ contractData?.trusteeContacts?.name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同分类</span>
              <span class="detail-value">
                <el-tag size="small"
                  :type="getContractColor(contractData.contractType, 'tagType')" :style="{
                    color: getContractColor(contractData.contractType, 'color'),
                    'background-color': getContractColor(contractData.contractType, 'backgroundColor'),
                    'border-color': getContractColor(contractData.contractType, 'borderColor')
                  }">
                  {{ getContractColor(contractData.contractType, 'name') }}</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">合同类型</span>
              <span class="detail-value">{{ contractData.projectType }}</span>
            </div>
            <div class="detail-item"
              v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(contractData.projectType)">
              <span class="detail-label">样品处理方式</span>
              <span class="detail-value">{{ contractData.sampleManagement === 'RETURN_SAMPLE' ? '返样' : '暂存样品' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">核酸抽提</span>
              <span class="detail-value">
                <el-tag size="small" type="success" v-if="contractData.generateContractInfo?.extractionFlag">是</el-tag>
                <el-tag size="small" type="danger" v-else>否</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">创建人</span>
              <span class="detail-value">{{ selectDetail.sponsor }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">创建时间</span>
              <span class="detail-value">{{ selectDetail.createTime }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">签订地点</span>
              <span class="detail-value">{{ contractData.signingPlace }}</span>
            </div>
            <div class="detail-item" v-if="contractData.priceFilePath">
              <span class="detail-label">价格申请截图</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(contractData.id, 'price')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(contractData.id, 'price')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item" v-if="contractData.contractFilePath">
              <span class="detail-label">合同</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(contractData.id, 'contract')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(contractData.id, 'contract')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width" v-if="findProjectAnnexProject(contractData)">
              <span class="detail-label">需做的理化性质列表</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="downloadProjectAnnexFile(contractData.id, findProjectAnnexProject(contractData).projectMainTypeId)">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="previewProjectAnnexFile(contractData.id, findProjectAnnexProject(contractData).projectMainTypeId)">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">备注</span>
              <span class="detail-value">{{ contractData.remark }}</span>
            </div>
          </div>
        </div>

        <!-- 补充分析要求 -->
        <div class="section-card"
          v-if="['预付款扣款（测序分析）', '测序分析'].includes(contractData.projectType) && contractData.contractType !== 'DEVELOPMENT' && contractData.moreAnalysisRequest && Object.keys(contractData.moreAnalysisRequest).length > 0">
          <div class="section-header-bar" @click="toggleSection('analysis')">
            <div class="section-title"><i class="el-icon-data-analysis"></i> 补充分析要求</div>
            <i :class="sectionOpen.analysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.analysis">
            <div class="detail-item" v-for="(item, index) in Object.keys(contractData.moreAnalysisRequest)" :key="index">
              <span class="detail-label">{{ analysis.find(itemA => itemA.label === item)?.name + '金额' }}</span>
              <span class="detail-value"><span class="amount-text">{{ formatAmount(contractData.moreAnalysisRequest[item]) }}</span></span>
            </div>
            <div class="detail-item" v-if="contractData.seniorAnalysisAnnex">
              <span class="detail-label">高级分析附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(contractData.id, 'senior')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(contractData.id, 'senior')">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item" v-if="contractData.customizedAnalysisAnnex">
              <span class="detail-label">个性化分析附件</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download" plain
                    @click="download(contractData.id, 'customized')">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view" plain
                    @click="preview(contractData.id, 'customized')">预览</el-button>
                </div>
              </span>
            </div>
          </div>
        </div>

        <!-- 返样 -->
        <div class="section-card"
          v-if="['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(contractData.projectType)">
          <div class="section-header-bar" @click="toggleSection('returnSample')">
            <div class="section-title"><i class="el-icon-refresh-left"></i> 返样</div>
            <i :class="sectionOpen.returnSample ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.returnSample">
            <div class="detail-item">
              <span class="detail-label">是否返样</span>
              <span class="detail-value">{{ contractData.generateContractInfo?.returnSampleBo?.returnSampleFlag ? '是' : '否' }}</span>
            </div>
            <div class="detail-item" v-if="contractData.generateContractInfo?.returnSampleBo?.returnSampleFlag">
              <span class="detail-label">服务费(返样)</span>
              <span class="detail-value"><span class="amount-text">{{
                formatAmount(contractData.generateContractInfo?.returnSampleBo?.returnSampleAmount) }}</span></span>
            </div>
            <div class="detail-item full-width"
              v-if="contractData.generateContractInfo?.returnSampleBo?.returnSampleFlag && Number(contractData.generateContractInfo?.returnSampleBo?.returnSampleAmount) === 0">
              <span class="detail-label">金额为0原因</span>
              <span class="detail-value">{{ contractData.generateContractInfo?.returnSampleBo?.reason }}</span>
            </div>
          </div>
        </div>

        <!-- 项目信息 -->
        <div class="section-card"
          v-if="contractData.specificProjectType && contractData.specificProjectType.length > 0">
          <div class="section-header-bar" @click="toggleSection('projectInfo')">
            <div class="section-title"><i class="el-icon-s-order"></i> 项目信息</div>
            <i :class="sectionOpen.projectInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-show="sectionOpen.projectInfo">
            <project-info-dialog :table-data="contractData.specificProjectType"></project-info-dialog>
          </div>
        </div>

        <!-- 纯分析项目信息 -->
        <div class="section-card" v-if="showPureAnalysisInfo">
          <div class="section-header-bar" @click="toggleSection('pureAnalysis')">
            <div class="section-title"><i class="el-icon-s-data"></i> 纯分析项目</div>
            <i :class="sectionOpen.pureAnalysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-show="sectionOpen.pureAnalysis">
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">纯分析类型</span>
                <span class="detail-value">{{ pureAnalysisTypeName }}</span>
              </div>
            </div>
            <!-- 合同-项目分组表格：每行一组，清晰展示绑定关系 -->
            <div class="change-data-wrapper" v-if="pureAnalysisTableData.length > 0">
              <el-table :data="pureAnalysisTableData" stripe style="width: 100%"
                header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }">
                <el-table-column label="序号" align="center" width="60">
                  <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="关联合同" align="center" min-width="180">
                  <template slot-scope="scope">
                    <span class="highlight-text">{{ scope.row.contractNumber }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="项目" align="center" min-width="250">
                  <template slot-scope="scope">
                    <el-tag v-for="(p, i) in scope.row.projects" :key="i" size="small"
                      style="margin: 2px 4px 2px 0;">{{ p }}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 解离项目投递方式信息展示 -->
        <div class="section-card" v-if="contractData.protectiveFluidInfo?.protectiveFluidMethod">
          <div class="section-header-bar" @click="toggleSection('deliveryInfo')">
            <div class="section-title"><i class="el-icon-truck"></i> 解离项目投递方式</div>
            <i :class="sectionOpen.deliveryInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.deliveryInfo">
            <div class="detail-item">
              <span class="detail-label">投递方式</span>
              <span class="detail-value">{{ contractData.protectiveFluidInfo.protectiveFluidMethod === 'DOOR' ? '上门' : (contractData.protectiveFluidInfo.protectiveFluidMethod === 'MAIL' ? '邮寄' : '') }}</span>
            </div>
            <template v-if="contractData.protectiveFluidInfo.protectiveFluidMethod === 'DOOR'">
              <div class="detail-item">
                <span class="detail-label">上门时间</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.doorInfo?.doorTime }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">上门费用</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.doorInfo?.doorFee }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">联系方式</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.doorInfo?.phone }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">上门地址</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.doorInfo?.address }}</span>
              </div>
            </template>
            <template v-if="contractData.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'">
              <div class="detail-item">
                <span class="detail-label">邮寄时间</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.materialMailInfo?.mailTime }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">收件人</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.materialMailInfo?.recipient }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">联系方式</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.materialMailInfo?.phone }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">收件地址</span>
                <span class="detail-value">{{ contractData.protectiveFluidInfo.materialMailInfo?.address }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
      <loading :loading="loading" load-text="提交中"></loading>
    </el-dialog>
  </div>
</template>

<script>
import { auditInfo } from "@/api/dilivery/audit";
import { getAllContract } from "@/api/dilivery/sales/contract";
import { getProjectList } from "@/api/dilivery/project";
import Loading from "@/components/loading/Loading.vue";
import FilePreview from "@/components/file/FilePreview.vue";
import ProjectInfoDialog from "@/components/sales/ProjectInfoDialog.vue";
import { getContractColor, getStatusColor } from "@/color";
import { getProportion } from "@/utils/float_decimal";
import projectAnnexMixin from "@/mixins/projectAnnexMixin";
import detailCommonMixin from "@/mixins/detailCommonMixin";

export default {
  name: "TeamAuditDialog",
  mixins: [projectAnnexMixin, detailCommonMixin],
  components: { Loading, FilePreview, ProjectInfoDialog },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    selectDetail: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'audit' // 'audit' 或 'details'
    }
  },
  data() {
    return {
      loading: false,
      showFile: false,
      fileInfo: '',
      enforceContractOption: [],
      ProjectOption: [],
      form: {
        id: '',
        status: '',
        rejectionReason: ''
      },
      rules: {
        status: [{ required: true, message: '审核状态不能为空', trigger: 'change' }],
        rejectionReason: [{ required: true, message: '驳回理由不能为空', trigger: 'change' }],
      },
      sectionOpen: {
        baseInfo: true,
        analysis: true,
        returnSample: true,
        projectInfo: true,
        pureAnalysis: true,
        deliveryInfo: true,
      },
      analysis: [
        { label: 'SENIOR_ANALYSIS', name: '高级分析' },
        { label: 'STANDARD_ANALYSIS', name: '标准分析' },
        { label: 'CUSTOMIZED_ANALYSIS', name: '个性化分析' },
      ],
    };
  },
  computed: {
    contractData() {
      return this.selectDetail.data || {}
    },
    pureAnalysisInfo() {
      return this.contractData.pureAnalysisInfo || {}
    },
    showPureAnalysisInfo() {
      const info = this.pureAnalysisInfo
      const hasContracts = Array.isArray(info.contracts) &&
        info.contracts.some(c => c.contractId || (c.projectIds && c.projectIds.length))
      return this.contractData.contractType === 'TEAM' &&
        this.contractData.projectType === '纯分析' &&
        !!(info.pureAnalysisType || hasContracts)
    },
    pureAnalysisTypeName() {
      // 与后端 pureAnalysisType 枚举保持一致
      const enumMap = {
        AFTER_SALES_ANALYSIS: '售后分析',
        RAW_DATA_RERELEASE: '原始数据重释放',
        PURE_ANALYSIS: '纯分析'
      }
      const val = this.pureAnalysisInfo.pureAnalysisType
      if (!val) return '-'
      return enumMap[val] || val
    },
    // 按组解析：每组包含 contractId / projectIds / 已加载的合同对象
    pureAnalysisContracts() {
      const contracts = Array.isArray(this.pureAnalysisInfo.contracts) ? this.pureAnalysisInfo.contracts : []
      return contracts.map(c => ({
        contractId: c.contractId,
        projectIds: Array.isArray(c.projectIds) ? c.projectIds : [],
        contract: c.contractId ? (this.enforceContractOption.find(x => String(x.id) === String(c.contractId)) || null) : null
      }))
    },
    // 按组生成表格数据：每行一组合同+项目，清晰展示绑定关系
    pureAnalysisTableData() {
      const list = this.pureAnalysisContracts
      if (list.length === 0) return []
      return list.map((g, idx) => {
        const spt = g.contract?.specificProjectType || []
        const projects = g.projectIds.map(pid => {
          // 优先从项目字典解析：仅展示具体项目名（不含 model 前缀）
          const dictItem = this.ProjectOption.find(item => String(item.id) === String(pid))
          if (dictItem) return dictItem.name
          // 兜底：从合同 specificProjectType 解析（兼容旧数据，仅展示具体项目名）
          const proj = spt.find(p => String(p.projectMainTypeId) === String(pid))
          return proj ? proj.projectType : pid
        })
        return {
          index: idx + 1,
          contractNumber: g.contract ? g.contract.contractNumber : (g.contractId || '-'),
          projects: projects.length ? projects : ['-']
        }
      })
    }
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.form.id = newVal.id;
          const data = newVal.data || {}
          if (data.contractType === 'TEAM' && data.projectType === '纯分析' && data.pureAnalysisInfo) {
            this.loadPureAnalysisOptions()
          }
        }
      },
      immediate: true
    },
  },
  methods: {
    getStatusColor,
    getContractColor,
    getProportion,
    // 加载纯分析项目展示所需的合同选项（按各组 contractId 定向获取）
    async loadPureAnalysisOptions() {
      try {
        // 加载项目字典（供纯分析项目名称解析，与 AddEditCRM.vue getProjectOptions 保持一致）
        if (this.ProjectOption.length === 0) {
          const projRes = await getProjectList({})
          if (projRes.code === 200) {
            this.ProjectOption = (projRes.data || []).filter(item => !item.deprecated)
          }
        }
        const contracts = Array.isArray(this.pureAnalysisInfo.contracts) ? this.pureAnalysisInfo.contracts : []
        const ids = contracts.map(c => c.contractId).filter(Boolean)
        if (ids.length === 0) return
        const typeMap = { AFTER_SALES_ANALYSIS: 'ANALYSIS_OVER_CONTRACT', RAW_DATA_RERELEASE: 'RELEASED_RAW_DATA_CONTRACT' }
        const contractType = typeMap[this.pureAnalysisInfo.pureAnalysisType]
        if (!contractType) return
        const missing = ids.filter(id => !this.enforceContractOption.some(c => String(c.id) === String(id)))
        if (missing.length === 0) return
        const res = await getAllContract(contractType, { 'query#id.IN': missing.join(',') })
        if (res.code === 200 && Array.isArray(res.data)) {
          this.enforceContractOption = [...this.enforceContractOption, ...res.data]
        }
      } catch (error) {
        console.log(error);
      }
    },
    async download(id, type) {
      await this.downloadContractAttachment(id, type)
    },
    async preview(id, type) {
      await this.previewContractAttachment(id, type)
    },
    async handleApprove() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          auditInfo(this.form).then(res => {
            this.loading = false;
            if (res.code === 200) {
              this.$messageUi.success('提交成功');
              this.$emit('submit', 'confirm');
              this.$store.commit('right/setChangeRed', true)
              if (this.form.status === 'SUCCESS') {
                this.$messageUi.success('已通过');
              } else {
                this.$messageUi.success('已驳回');
              }
            }
          }).catch(err => {
            this.loading = false;
          });
        } else {
          this.$messageUi.error('信息填写不完整,请检查');
        }
      });
    },
    cancel() {
      this.$emit('submit', 'cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";

.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}
.audit-form {
  padding: 16px;
}
.success-radio {
  margin-right: 20px;
}
.danger-radio {
  margin-right: 0;
}
</style>
